import { Button } from "antd";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import CustomerIdCell from "src/utils/customerIdCell";
import { badge } from "src/utils/statusColorsCode";



export const CustomerEmailHandler = ({ data, customerDetailsHandler }) => {
  return <td onClick={() => customerDetailsHandler(data)}>
    <span className="text-link cursor-pointer">{data?.email}</span>
  </td>
}

export const KycStatusHandler = ({ data }) => {
  return (data?.kycorkybVerified ?
    <td><span className={`status-badge ${badge[data?.kycorkybVerified?.toLowerCase()] || 'bg-green'}`}>{data?.kycorkybVerified}</span></td>
    : <td></td>
  )
}

export const StatusHandler = ({ data }) => {
  return (data?.state ?
    <td><span className={`status-badge ${badge[data?.state?.toLowerCase()] || 'bg-green'}`}>{data?.state}</span></td>
    : <td></td>
  )
}

export const RegisteredDateHandler = ({ data }) => {
  return (<td>
    <div>
      {data?.registerDate ? <> {moment.utc(data?.registerDate).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.registerDate}
    </div>
  </td>
  )
}

export const ApprovedDateHandler = ({ data }) => {
  return (<td>
    <div>
      {data?.approvedDate ? <> {moment.utc(data?.approvedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.approvedDate}
    </div>
  </td>
  )
}


export const DateColumnHandler = ({ data }) => {
  const date = data?.dataItem?.applyTime;
  return (
    <td>
      <div className="gridLink text-light-valueColor">
        {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
      </div>
    </td>
  )
}
export const StatusColumnHandler = ({ data, badge }) => {
  const state = data?.dataItem?.state
  return (
    <td> <span className={`status-badge ${badge[state?.toLowerCase()] || 'bg-green'}`}>{state}</span></td>
  )
}

export const NumberFormatter = ({ value }) => {
  return <td>
    <NumericFormat
      value={value}
      decimalScale={2}
      thousandSeparator={true}
      thousandsGroupStyle="lakh"
      displayType="text"
    />
  </td>
};

export const TransactionsIdColumnHandler = ({ data, copiedId, handleIdCopy }) => {
  const transactionId = data?.dataItem?.transactionId;
  return (<td>
    <CustomerIdCell customerId={transactionId} copied={copiedId} handleCopy={handleIdCopy} />
  </td>)
}

export const DownloadButton = ({ handleDownload, imageUrl }) => {
  return (
    <Button key="download" type="primary" onClick={handleDownload(imageUrl)} className='primary-btn px-4 py-1 rounded-5 font-medium'>
      Download
    </Button>
  )
}